module.exports = __webpack_public_path__ + "img/4.be67348c.gif";